<template>
  <div>
    <div align="right" style="margin: 10px">
      <Button color="primary" :loading="loading" @click="save">保存映射</Button>
    </div>
    <vxe-table
        border
        show-overflow
        size="mini"
        highlight-hover-row
        :loading="loading"
        :data="supplierList">
      <vxe-column type="seq" width="60"></vxe-column>
      <vxe-column field="code" title="编码"></vxe-column>
      <vxe-column field="name" title="进销存供货商名称"></vxe-column>
      <vxe-column title="类型" width="100">
        <template #default="{row}">
          {{ row.type === 2 ? '客户' : '供应商' }}
        </template>
      </vxe-column>
      <vxe-column field="subjectId" title="财务系统科目">
        <template #default="{row}">
          <Select v-model="row.subjectId" :datas="subjectList" keyName="id" titleName="name"
                  :filterable="true" style="width: 100%"></Select>
        </template>
      </vxe-column>
    </vxe-table>
  </div>
</template>

<script>
import {mapState} from "vuex";

/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2020 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : financial</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2022/6/15 13:43</li>
 * <li>@author     : ____′↘TangSheng</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "SupplierMapping",
  data() {
    return {
      supplierList: [],
      subjectList: [],
      loading: false,
    }
  },
  computed: {
    ...mapState(["currentAccountSets"]),
  },
  methods: {
    init() {
      if (this.currentAccountSets.token) {
        this.loading = true;
        Promise.all([
          this.$api.setting.Inventory.supplier(),
          this.$api.setting.Inventory.getSupplierMapping(),
          this.$api.setting.subject.voucherSelect({})
        ]).then((results) => {
          let supplierList = results[0].data || [];
          let mappings = results[1].data || [];
          this.subjectList = results[2].data || [];
          let subjectMap = {};
          mappings.forEach(val => {
            subjectMap[val.supplierId] = val.subjectId;
          });
          supplierList.forEach(val => {
            this.$set(val, 'subjectId', subjectMap[val.id] !== undefined ? subjectMap[val.id] : (val.subjectId || null));
          });
          this.supplierList = supplierList;
        }).finally(() => this.loading = false);
      } else {
        this.$Message.error("请先进行进销存设置");
      }
    },
    save() {
      if (!this.supplierList.length) {
        this.$Message.error("没有可保存的供应商");
        return;
      }
      //提交全部行，subjectId 为 null 表示清空该供应商的科目映射
      let array = this.supplierList.map(val => ({
        supplierId: val.id, subjectId: val.subjectId || null
      }));
      this.loading = true;
      this.$api.setting.Inventory.supplierMapping(array).then(() => {
        this.$Message('映射成功~');
      }).finally(() => this.loading = false);
    }
  },
  created() {
    this.init();
  }
}
</script>

<style scoped lang="less">
.form {
  border: @border;
  margin: 30px auto;
  padding: 30px;
  width: 800px;
}

.sys-border {
  padding-left: 10px !important;
  border: 1px solid #f1556c;
}
</style>
